<!-- @format -->

<ng-container *transloco="let t">
  @if (searchService.searchParameters$ | async; as searchParameters) {
    @let fullTextQueryLength = searchParameters.filters?.fullTextQuery?.length;
    @let minFullTextQueryLength = searchService.minFullTextQueryLength;
    @if (isSearchValid(searchParameters, minFullTextQueryLength)) {
      <ng-content />
    } @else if ((fullTextQueryLength && fullTextQueryLength < minFullTextQueryLength) || fullTextQueryLength > maxQueryLength) {
      <p id="search-error-message" class="guidance" data-cy="search-results-query-guidance">
        @let difference = minFullTextQueryLength - fullTextQueryLength;
        @if (difference === 1) {
          {{ t("SEARCH.TYPE_ONE_MORE_LETTER") }}
        } @else if (difference === 2) {
          {{ t("SEARCH.TYPE_TWO_MORE_LETTERS") }}
        } @else if (difference > 2) {
          {{ t("SEARCH.TYPE_N_MORE_LETTERS", { count: difference }) }}
        } @else if (fullTextQueryLength > maxQueryLength) {
          {{ t("SEARCH.QUERY_TEXT_TOO_LONG") }}
        }
      </p>
    }
  }
</ng-container>
